import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-click-to-copy',
  templateUrl: './click-to-copy.component.html',
  styleUrls: ['./click-to-copy.component.scss']
})
export class ClickToCopyComponent {
  @Input() text: string;

  constructor() {
    // intentionally empty
  }

  copyToClipboard(event) {
    if (!this.isAllowToCopy()) {
      return;
    }

    event.stopPropagation();

    const clipboard = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', this.text);
      e.preventDefault();
      document.removeEventListener('copy', clipboard);
    };

    document.addEventListener('copy', clipboard);
    document.execCommand('copy');
  }

  isAllowToCopy() {
    return this.text === '(None)' || this.text === '-' || this.text === null ? false : true;
  }
}
